/* eslint-disable react/jsx-key */
import React, { lazy } from "react";
import UnauthorizedRoute from "base-shell/lib/components/UnauthorizedRoute";
import PageNotFound from "pages/PageNotFound/PageNotFound";
import AuthorizedRoute from "components/AuthorizedRoute";

const SignIn = lazy(() => import("../pages/SignIn/SignIn"));
const EnterPinScreen = lazy(() => import("pages/auth/pin/pin"));
const Login = lazy(() => import("../pages/auth/login/login"));
const Register = lazy(() => import("../pages/auth/register/register"));
const SetupProfile = lazy(() =>
  import("../pages/auth/setup-profile/setupProfile")
);
const FillAddress = lazy(() =>
  import("../pages/auth/setup-profile/fillAddress")
);
const RegisterComplete = lazy(() =>
  import("../pages/auth/register/registerComplete")
);
const PatientsList = lazy(() => import("../pages/patients/patientsList"));
const GenaricTable = lazy(() => import("../pages/patients/GenaricTable"));
const OrdersList = lazy(() => import("../pages/testOrders/OrdersList"));
const OrderSuccess = lazy(() => import("../pages/testOrders/OrderSuccess"));
const LabSyncLogs = lazy(() => import("pages/labSyncLogs/LabSyncLogs"));
const PaymentSuccess = lazy(() => import("../pages/payment/PaymentSuccess"));
const PaymentCancel = lazy(() => import("../pages/payment/PaymentCancel"));
const PatientsProfile = lazy(() => import("../pages/patients/patientProfile"));
const TestDetails = lazy(() => import("../pages/patients/testDetails"));
const TestDetailsDocs = lazy(() => import("../pages/patients/testDetailsDocs"));
const DoctorProfile = lazy(() => import("../pages/doctor/doctorProfile"));
const AccountSetting = lazy(() => import("../pages/doctor/accountSetting"));
const BlogPosts = lazy(() => import("../pages/Blog/BlogPosts"));
const PostDetails = lazy(() => import("../pages/Blog/PostDetails"));
const ForgetPassword = lazy(() =>
  import("../pages/auth/forget-password/forget-password")
);
const ResetPassword = lazy(() =>
  import("../pages/auth/forget-password/resetPassword")
);
const AccountVerified = lazy(() =>
  import("../pages/auth/login/accountVerified")
);
const VerifyFromMobile = lazy(() =>
  import("../pages/auth/login/verifyFromMobile")
);
const CheckEmail = lazy(() =>
  import("../pages/auth/forget-password/checkEmail")
);
const CheckOtp = lazy(() => import("../pages/auth/forget-password/checkOtp"));

const SignUp = lazy(() => import("../pages/SignUp/SignUp"));
const PasswordReset = lazy(() =>
  import("../pages/PasswordReset/PasswordReset")
);
const About = lazy(() => import("../pages/About"));
const Home = lazy(() => import("../pages/Home/Home"));
const MyAccount = lazy(() => import("../pages/MyAccount/MyAccount"));
const DeleteAccount = lazy(() => import("../pages/DeleteAccount"));

const routes = [
  {
    path: "/signin",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <SignIn redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/login",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <Login redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/forgetPassword",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <ForgetPassword redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/resetPassword",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <ResetPassword redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/checkOtp",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <CheckOtp redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/CheckEmail",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <CheckEmail redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/register",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <Register redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/app/verify-email/:Code",
    exact: true,
    element: <AccountVerified redirectTo="/home" />,
  },
  {
    path: "/app/change_email",
    exact: true,
    element: <VerifyFromMobile redirectTo="/home" />,
  },
  {
    path: "/setupProfile",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <SetupProfile redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/fillAddress",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <FillAddress redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/registerComplete",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <RegisterComplete redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },

  {
    path: "/",
    exact: true,
    element: (
      <AuthorizedRoute>
        <PatientsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/patientsList",
    exact: true,
    element: (
      <AuthorizedRoute>
        <PatientsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/patientsProfile",
    exact: true,
    element: (
      <AuthorizedRoute>
        <PatientsProfile />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/testDetailsDocs",
    exact: true,
    element: (
      <AuthorizedRoute>
        <TestDetailsDocs />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/testDetails",
    exact: true,
    element: (
      <AuthorizedRoute>
        <TestDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/doctorProfile",
    exact: true,
    element: (
      <AuthorizedRoute>
        <DoctorProfile />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/pin",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <EnterPinScreen />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/blog",
    exact: true,
    element: (
      <AuthorizedRoute>
        <BlogPosts />
      </AuthorizedRoute>
    ),
  },
  {
    path: "blog/post/:id",
    exact: true,
    element: (
      <AuthorizedRoute>
        <PostDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/accountSetting",
    exact: true,
    element: (
      <AuthorizedRoute>
        <AccountSetting />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/genaric-table",
    exact: true,
    element: (
      <AuthorizedRoute>
        <GenaricTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/orders",
    exact: true,
    element: (
      <AuthorizedRoute>
        <OrdersList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/lab-sync-logs",
    exact: true,
    element: (
      <AuthorizedRoute>
        <LabSyncLogs />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/order-success",
    exact: true,
    element: <OrderSuccess />,
  },
  {
    path: "/payment/success",
    exact: true,
    element: <PaymentSuccess />,
  },
  {
    path: "/payment/cancel",
    exact: true,
    element: (
      <AuthorizedRoute>
        <PaymentCancel />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/signup",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <SignUp redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/password_reset",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <PasswordReset redirectTo="/home" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/delete_account",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <DeleteAccount redirectTo="/my_account" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/app/delete-user-account",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <DeleteAccount redirectTo="/my_account" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/app/delete-user-account/:token",
    exact: true,
    element: (
      <UnauthorizedRoute>
        <DeleteAccount redirectTo="/my_account" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: "/about",
    exact: true,
    element: <About />,
  },
  {
    path: "/my_account",
    exact: true,
    element: (
      <AuthorizedRoute>
        <MyAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/home",
    exact: true,
    element: (
      <AuthorizedRoute>
        <Home />
      </AuthorizedRoute>
    ),
  },
  {
    path: "*",
    exact: true,
    element: <PageNotFound />,
  },
];

export default routes;
